module.exports = __webpack_public_path__ + "static/media/trustpilot-logo.aad670ff.svg";